import { useState } from 'react';

import { Controller, useForm } from 'react-hook-form';

import { CommonModal } from '../CommonModal';
import './ModalCompanyInfo.scss';

import { EditCompanyRequestType } from 'api';
import { CommonModalType, ReturnComponentType } from 'common';
import { commonValidation } from 'config';
import { useAppSelector, useTypedDispatch } from 'hooks';
import {
  editCompany,
  fetchCertainCompany,
  selectCertainCompany,
  selectUser,
} from 'state';
import { Button, InputForm } from 'ui-kit';
import { checkIsGoodStatus } from 'utils';

export const ModalCompanyInfo = ({
  showModal,
  setShowModal,
}: CommonModalType): ReturnComponentType => {
  const dispatch = useTypedDispatch();
  const company = useAppSelector(selectCertainCompany);
  const user = useAppSelector(selectUser);
  const [companyName, setCompanyName] = useState(company.name);

  const { handleSubmit, control, reset } = useForm<EditCompanyRequestType>({
    defaultValues: {
      name: user?.company.name ?? '',
    },
  });

  const closeModal = () => {
    setShowModal(false);
  };

  const onSaveClick = async () => {
    const status = await dispatch(editCompany(companyName, user.company?.id));

    if (checkIsGoodStatus(status)) {
      reset();
      dispatch(fetchCertainCompany(user.company.id));
      closeModal();
    }
  };

  return (
    <CommonModal closeModal={closeModal} showModal={showModal}>
      <div className="ModalCompanyInfo">
        <header className="ModalCompanyInfo_Header">
          <div className="ModalCompanyInfo_Header_Title">Edit Company</div>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div onClick={closeModal} className="ModalCompanyInfo_Header_Close">
            &#10006;
          </div>
        </header>

        <form className="ModalCompanyInfo_Form" onSubmit={handleSubmit(onSaveClick)}>
          <section>
            <Controller
              control={control}
              name="name"
              rules={commonValidation}
              render={({ field }) => (
                <InputForm
                  label="Company Name"
                  placeholder="Company name"
                  value={companyName}
                  onChange={e => setCompanyName(e.currentTarget.value)}
                />
              )}
            />
          </section>
          <Button type="submit" className="ModalCompanyInfo_Form_Submit">
            Save
          </Button>
        </form>
      </div>
    </CommonModal>
  );
};
